import { render, staticRenderFns } from "./TileDashboardComercial.vue?vue&type=template&id=1d646f3f&"
import script from "./TileDashboardComercial.vue?vue&type=script&lang=js&"
export * from "./TileDashboardComercial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\MasterBranches\\Maintenance_06.04\\Fontes\\corp\\produto\\wes\\WebApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d646f3f')) {
      api.createRecord('1d646f3f', component.options)
    } else {
      api.reload('1d646f3f', component.options)
    }
    module.hot.accept("./TileDashboardComercial.vue?vue&type=template&id=1d646f3f&", function () {
      api.rerender('1d646f3f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "content/components/ui/TileDashboardComercial.vue"
export default component.exports